var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"histroy"},[_c('div',{staticClass:"histroy_top"},[_c('strong',{staticClass:"histroy_name"},[_vm._v("历史搜索")]),_c('span',{staticClass:"histroy_clear",on:{"click":_vm.deletestoreKeys}},[_vm._v("清除")])]),_vm._v(" "),_c('div',{staticClass:"histroy_keyWords_wrapper"},_vm._l((_vm.histroyKeyWords),function(localHistoryKey,index){return _c('router-link',{key:index,staticClass:"histroy_keyWords",attrs:{"to":{name:'searchResulte',query:{
      keyWord:localHistoryKey

    }}}},[_vm._v(_vm._s(localHistoryKey.slice(0,6)))])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29ebc9cd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/histroyKeyWords.vue
// module id = null
// module chunks = 